import { array, bool, mixed, number, object, type ObjectSchema } from 'yup';

import type { DashboardItem } from 'types';
import type { FormValues } from 'components/admin/core/Settings/Dashboard';

export const useDashboardSchema = () => {
  return object({
    dashboard: array()
      .of(
        object({
          type: mixed<DashboardItem['type']>().required(),
          row: number().required(),
          viewMode: mixed(),
          items: mixed(),
        })
      )
      .required()
      .default([]),
    showCounts: bool(),
  }) as ObjectSchema<FormValues>;
};
